import { LazyLoadImage } from "react-lazy-load-image-component";
import Avatar from "../Avatar";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import currency from "currency.js";
import { useState } from "react";
import { s3Link } from "../../utils/constants";
import styled from "styled-components";

const List = styled.li`
    font-size: 16px;
    list-style: none;
    &::before {
        content: "\f058";
        font-family: "Font Awesome\ 6 Pro";
        color: #0097fe;
        margin-right: 8px;
    }
`;

const CoverAvatar = ({ user, price, isPromo = false }) => {
    const SubscribeTo = () => {
        return (
            <>
                Subscribe to <span className="text-blue">@{user.login}</span>{" "}
            </>
        );
    };

    const RenderPrice = () => {
        if (isPromo) {
            return (
                <>
                    <span className="text-blue">
                        {currency(price).format({ precision: 2 })}*
                    </span>{" "}
                    for the first month
                </>
            );
        }

        if (
            user.creator &&
            Object.keys(user.creator.promo_details).length > 0
        ) {
            return (
                <>
                    <span className="text-blue">
                        {currency(
                            user.creator.promo_details.promo_price
                        ).format({ precision: 2 })}
                        *
                    </span>{" "}
                    for the first month
                </>
            );
        }

        return (
            <>
                <span className="text-blue">
                    {currency(user.creator.subscription_price).format({
                        precision: 2,
                    })}
                    *
                </span>{" "}
                USD/month
            </>
        );
    };

    return (
        <div>
            <div
                css={css`
                    display: flex;
                    @media (max-width: 899px) {
                        display: block;
                        width: 100%;
                    }
                `}
            >
                <div
                    css={css`
                        flex: 1;

                        @media (max-width: 899px) {
                            display: block;
                            width: 100%;
                        }
                    `}
                >
                    <div
                        css={css`
                            background-image: url(${s3Link}/${user.id}/cover_photo.jpg?t=${user.cover_photo_updated_at
                                ? user.cover_photo_updated_at
                                : new Date().valueOf()});
                            background-size: cover;
                            background-position: center center;
                            width: 100%;
                            min-height: 118px;
                        `}
                    ></div>

                    <div
                        css={css`
                            margin-top: -45px;
                            display: flex;
                            justify-content: center;
                        `}
                    >
                        <Avatar pu={user} story={false} size="100" />
                    </div>

                    <div
                        className="text-blue"
                        css={css`
                            text-align: center;
                        `}
                    >
                        @{user.login}{" "}
                        <LazyLoadImage
                            src="/images/tick_small_edit.png"
                            width="22"
                            className="ml-1"
                            style={{ marginBottom: "7px" }}
                        />
                    </div>
                </div>

                <div
                    css={css`
                        flex: 0 0 58.33333333%;

                        @media (max-width: 899px) {
                            display: block;
                            width: 100%;
                        }
                    `}
                >
                    <div className="signup__details__container">
                        <div className="signup__header">
                            <SubscribeTo />
                            <RenderPrice />
                        </div>

                        <ul
                            css={css`
                                padding: 0;
                            `}
                        >
                            <List>
                                Full Access to this creator's exclusive content
                            </List>
                            <List>Direct message with this creator </List>
                            <List>
                                Request personalised Pay Per View content
                            </List>
                            <List>Cancel your subscription at any time</List>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoverAvatar;
